/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DecisionPollReport', 'model/InsightImage', 'model/InsightLinkReport', 'model/InsightReactionLink', 'model/InsightTaggedUser'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./DecisionPollReport'), require('./InsightImage'), require('./InsightLinkReport'), require('./InsightReactionLink'), require('./InsightTaggedUser'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.InsightReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DecisionPollReport, root.ForStractionServiceApi.InsightImage, root.ForStractionServiceApi.InsightLinkReport, root.ForStractionServiceApi.InsightReactionLink, root.ForStractionServiceApi.InsightTaggedUser);
  }
}(this, function(ApiClient, DecisionPollReport, InsightImage, InsightLinkReport, InsightReactionLink, InsightTaggedUser) {
  'use strict';




  /**
   * The InsightReport model module.
   * @module model/InsightReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>InsightReport</code>.
   * @alias module:model/InsightReport
   * @class
   */
  var exports = function() {
    var _this = this;





















  };

  /**
   * Constructs a <code>InsightReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InsightReport} obj Optional instance to populate.
   * @return {module:model/InsightReport} The populated <code>InsightReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Images')) {
        obj['Images'] = ApiClient.convertToType(data['Images'], [InsightImage]);
      }
      if (data.hasOwnProperty('Reactions')) {
        obj['Reactions'] = ApiClient.convertToType(data['Reactions'], [InsightReactionLink]);
      }
      if (data.hasOwnProperty('TaggedUsers')) {
        obj['TaggedUsers'] = ApiClient.convertToType(data['TaggedUsers'], [InsightTaggedUser]);
      }
      if (data.hasOwnProperty('Links')) {
        obj['Links'] = ApiClient.convertToType(data['Links'], [InsightLinkReport]);
      }
      if (data.hasOwnProperty('Poll')) {
        obj['Poll'] = DecisionPollReport.constructFromObject(data['Poll']);
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('LastUpdate')) {
        obj['LastUpdate'] = ApiClient.convertToType(data['LastUpdate'], 'Date');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ReplyToInsightID')) {
        obj['ReplyToInsightID'] = ApiClient.convertToType(data['ReplyToInsightID'], 'Integer');
      }
      if (data.hasOwnProperty('MainParentInsightID')) {
        obj['MainParentInsightID'] = ApiClient.convertToType(data['MainParentInsightID'], 'Integer');
      }
      if (data.hasOwnProperty('RecentReplyInsightID')) {
        obj['RecentReplyInsightID'] = ApiClient.convertToType(data['RecentReplyInsightID'], 'Integer');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('ExternalLinkURI')) {
        obj['ExternalLinkURI'] = ApiClient.convertToType(data['ExternalLinkURI'], 'String');
      }
      if (data.hasOwnProperty('BusinessEmoji')) {
        obj['BusinessEmoji'] = ApiClient.convertToType(data['BusinessEmoji'], 'String');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('IsPrivate')) {
        obj['IsPrivate'] = ApiClient.convertToType(data['IsPrivate'], 'Boolean');
      }
      if (data.hasOwnProperty('TargetPeriodDate')) {
        obj['TargetPeriodDate'] = ApiClient.convertToType(data['TargetPeriodDate'], 'Date');
      }
      if (data.hasOwnProperty('CustomUserName')) {
        obj['CustomUserName'] = ApiClient.convertToType(data['CustomUserName'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/InsightImage>} Images
   */
  exports.prototype['Images'] = undefined;
  /**
   * @member {Array.<module:model/InsightReactionLink>} Reactions
   */
  exports.prototype['Reactions'] = undefined;
  /**
   * @member {Array.<module:model/InsightTaggedUser>} TaggedUsers
   */
  exports.prototype['TaggedUsers'] = undefined;
  /**
   * @member {Array.<module:model/InsightLinkReport>} Links
   */
  exports.prototype['Links'] = undefined;
  /**
   * @member {module:model/DecisionPollReport} Poll
   */
  exports.prototype['Poll'] = undefined;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} LastUpdate
   */
  exports.prototype['LastUpdate'] = undefined;
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} ReplyToInsightID
   */
  exports.prototype['ReplyToInsightID'] = undefined;
  /**
   * @member {Integer} MainParentInsightID
   */
  exports.prototype['MainParentInsightID'] = undefined;
  /**
   * @member {Integer} RecentReplyInsightID
   */
  exports.prototype['RecentReplyInsightID'] = undefined;
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {String} ExternalLinkURI
   * @default ''
   */
  exports.prototype['ExternalLinkURI'] = '';
  /**
   * @member {String} BusinessEmoji
   * @default ''
   */
  exports.prototype['BusinessEmoji'] = '';
  /**
   * @member {Integer} Sort
   */
  exports.prototype['Sort'] = undefined;
  /**
   * @member {Boolean} IsPrivate
   * @default false
   */
  exports.prototype['IsPrivate'] = false;
  /**
   * @member {Date} TargetPeriodDate
   */
  exports.prototype['TargetPeriodDate'] = undefined;
  /**
   * @member {String} CustomUserName
   * @default ''
   */
  exports.prototype['CustomUserName'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


